import type { ColorKey } from '@skolveckan/shared';

/**
 * Enda bryggan mellan ett ämnes colorKey och faktiska färger. Komponenter
 * använder den här, aldrig hex-koder. Värdena bor i styles/tokens.css.
 */
export interface SubjectColors {
  fill: string;
  line: string;
  ink: string;
}

export function subjectColors(key: ColorKey | null | undefined): SubjectColors {
  const k = key ?? 'break';
  return {
    fill: `var(--subject-${k}-fill)`,
    line: `var(--subject-${k}-line)`,
    ink: `var(--subject-${k}-ink)`,
  };
}

/** Används i legender och små prickar. */
export const SUBJECT_GROUPS: { key: ColorKey; label: string }[] = [
  { key: 'math', label: 'Matematik' },
  { key: 'swedish', label: 'Svenska' },
  { key: 'english', label: 'Engelska' },
  { key: 'social', label: 'SO' },
  { key: 'science', label: 'NO' },
  { key: 'sports', label: 'Idrott' },
  { key: 'craft', label: 'Slöjd & Bild' },
];
